module.exports = __webpack_public_path__ + "img/part5-6.6d190644.png";